
<app-show-documents-multiple [referenceType]="entityReferenceType" [referenceId]="entityId" [allowUpload]="true"
[uploadFilesSettings]="uploadFilesSettings" [sortDirection]="'DESC'"></app-show-documents-multiple>